import React from 'react'
import { Box } from '@workwhile/ui'
import { InvoiceConfigHeader } from './InvoiceConfigHeader'
import { InvoiceConfigFilters } from './InvoiceConfigFilters'
import { InvoiceConfigTable } from './InvoiceConfigTable'

export const InvoiceConfigMain = () => {
  return (
    <>
      <InvoiceConfigHeader />
      <Box margin={3}>
        <InvoiceConfigFilters />
        <InvoiceConfigTable />
      </Box>
    </>
  )
}
